import {
  type ApolloClient,
  type NormalizedCacheObject,
  gql,
} from '@apollo/client';
import { checkInvalidDate } from '../../../Application/graphql';
import { type ApplicantInformation } from '../../../UserInfo/graphql';

const GET_APPLICANT_INFORMATION_BY_FILTER = gql`
  query ($filter: ApplicantFilter) {
    applicants(filter: $filter) {
      email
      name {
        givenName
        surname
        chineseName
      }
      gender
      dateOfBirth
      identity {
        identityType
        identityDocumentType
        identityDocumentNumber
        isLocal
        needStudentVisa
      }
      nationality
      province
      addressLine1
      addressLine2
      addressLine3
      addressCountryRegion
      mobileNumber
      telephoneNumber
      disabilitySpecial {
        disabilitySpecialType
        disabilitySpecialDetail
      }
      _id
    }
  }
`;

export const useGetApplicantByFilter = async (
  client: ApolloClient<NormalizedCacheObject>,
  filter: any,
): Promise<any> => {
  const { data } = await client.query({
    query: GET_APPLICANT_INFORMATION_BY_FILTER,
    variables: { filter },
    fetchPolicy: 'network-only',
  });

  let applicant: ApplicantInformation = {
    email: '',
    givenName: '',
    surname: '',
    gender: '',
    dateOfBirth: '',
    identityType: '',
    identityDocumentNumber: '',
    identityDocumentType: '',
    isLocal: false,
    needStudentVisa: false,
    nationality: '',
    province: '',
    addressCountryRegion: '',
    addressLine1: '',
    mobileNumber: '',
    telephoneNumber: '',
    id: '',
    disabilitySpecialType: '',
    disabilitySpecialDetail: '',
  };

  const applicantData = data?.applicants[0] ?? {};

  const {
    _id,
    email,
    name,
    gender,
    dateOfBirth,
    identity,
    nationality,
    province,
    addressCountryRegion,
    addressLine1,
    addressLine2 = '',
    addressLine3 = '',
    mobileNumber,
    telephoneNumber,
    disabilitySpecial,
  } = applicantData;

  applicant = {
    id: _id,
    email,
    givenName: name?.givenName ?? '',
    surname: name?.surname ?? '',
    chineseName: name?.chineseName ?? '',
    gender,
    dateOfBirth: checkInvalidDate(dateOfBirth) ? '' : String(dateOfBirth),
    identityType: identity?.identityType ?? '',
    identityDocumentType: identity?.identityDocumentType ?? '',
    identityDocumentNumber: identity?.identityDocumentNumber ?? '',
    isLocal: identity?.isLocal ?? false,
    needStudentVisa: identity?.needStudentVisa ?? false,
    nationality,
    province,
    addressCountryRegion,
    addressLine1,
    addressLine2,
    addressLine3,
    mobileNumber,
    telephoneNumber,
    disabilitySpecialType: disabilitySpecial?.disabilitySpecialType ?? 'NA',
    disabilitySpecialDetail:
      disabilitySpecial?.disabilitySpecialDetail ?? undefined,
  };

  return applicant;
};
